import { DoorConfiguration } from '../../configurator/DoorConfiguration';
import mountingMaterialService from '../../services/Configurator/MountingMaterialService';
import functionsService from '../../services/Configurator/FunctionsService';
import { Characteristic, ValueDefinition, MountingMaterialItem, MountingMaterialItemToSapData, MapCharacteristicAndValue } from '../../configurator/types';
import store from '@/store/index';
import '../../configurator/types';
import {filterMountingMaterialColor} from "@/configurator/Helpers/StoreHelpers";


interface ExteriorStore {
    model: any;
    defaultCharacteristicObject: any;
    mountingMaterialListItems: MountingMaterialItem[];
    mountingMaterialListItemsForSap: MountingMaterialItemToSapData[];
}

const initialState: ExteriorStore = {
    model: {
        modelUnlocked: false,
        characteristics: [],
        childCharacteristics: [],
        modelStatus: {
            active: false,
        },
    },
    defaultCharacteristicObject: {
        id: 0,
        description: 'Static Characteristic Description',
        code: 'CHARACTERISTIC_CODE',
        values: [
            {
                id: 0,
                description: 'Static Value Description',
                value: 'No Val',
                resource: '',
            },
        ],
    },
    mountingMaterialListItems: [],
    mountingMaterialListItemsForSap: [],
};

const getDefaultState = () => {
    return initialState;
};

const state = getDefaultState();

const getters = {
    getStepCharacteristics: (s: any) => s.model.characteristics,
    // This should be used for displaying characteristics and values in components (should replace all getKTU_MM_XYZ)
    getCharacteristicAndValues: (s: any) => {
        return (characteristicCode: string) => getCharacteristic(characteristicCode, s);
    },
    getNrOfValuesByCharacteristic: (s: any) => {
        return (characteristicCode: string) => getNrOfValues(characteristicCode, s);
    },
    checkRadioValue: (s: any) => {
        return (characteristicCode: string, value: string) => checkValue(characteristicCode, value, s);
    },
    getMountingMaterialsList: (s: any) => {
        return s.mountingMaterialListItems;
    },
    getChildCharacteristics: (s: any) => {
        return s.model.childCharacteristics;
    },
    getMountingMaterialItemsForSap: (s: any) => {
        return s.mountingMaterialListItemsForSap;
    }
};

const actions = {
    setStepCharacteristics(context: any, payload: any) {
        context.commit('updateStepCharacteristics', payload);
    },
    setChildCharacteristics(context: any) {
        // const mountingMaterialParentChars: string[] = ['KTU_MM_ABDECKLEISTE', 'KTU_MM_WINKEL', 'KTU_MM_BLINDSTOCK_MM', 'KTU_MM_MDF'];
        const mountingMaterialParentChars: string[] = ['KTU_MM_ABDECKLEISTE', 'KTU_MM_WINKEL', 'KTU_MM_MDF'];

        mountingMaterialService.getChildCharacteristicsByParentCharacteristicCodes(mountingMaterialParentChars).then((response: any) => {
            context.commit('updateChildCharacteristics', response.data);
        });
    },
    setCharacteristicDependencies(context: any, { anchorCharacteristic, dependencieCharacteristic }: any) {
        const anchor: Characteristic = anchorCharacteristic;
        let filteredDependencies = [];
        for(let i = 0; i< dependencieCharacteristic.length; i++) {
            filteredDependencies.push(`${dependencieCharacteristic[i].id}-${dependencieCharacteristic[i].value.id}`);
        }
        let finalToFitler = filteredDependencies.join("|");
        if(finalToFitler != "") {
            functionsService.extractDependencies(anchor.id, finalToFitler)
                .then((response: any) => {
                    context.commit('updateCharacteristicDependencies', response.data);
                });
        }

    },
    addCharacterisitc(context: any, { characteristic, valueDefinition }: any) {
        const selectedCharacteristic = MapCharacteristicAndValue(characteristic, valueDefinition);
        const configuration = context.rootState.configuratorModule.doorConfiguration;
        configuration.Add(DoorConfiguration.Measure, selectedCharacteristic);
    },
    valueAddCharacteristic(context: any, { characteristicValue, value }: any) {
        characteristicValue.values[0].value = value;
        const selectedCharacteristic = MapCharacteristicAndValue(characteristicValue, characteristicValue.values[0]);
        context.rootState.configuratorModule.doorConfiguration.AddNumericCharacteristic(DoorConfiguration.Measure, selectedCharacteristic);
        // setDoorWidthMeasurementsFormula(context.rootState.doorConfiguration);
    },
    setSingleCharacteristicsFilteredOrDefaults(context: any) {
        context.commit('updateSingleCharacteristicsFilteredOrDefaults');
    },
    addMountingMaterial(context: any, payload: any) {
        context.commit('updateMountingMaterialList', payload);
    },
    addMountingMaterialForSap(context: any, payload: any) {
        context.commit('updateMountingMaterialListForSap', payload);
    },
    updateBlindstockForSap(context: any, payload: any) {
        context.commit('updateBlindstockForSap', payload);
    },
    clearMountingMaterialList(context: any, payload : any) {
        context.commit('clearMountingMaterialList', payload);
    },
    initMountingMaterialModule(context : any, payload : any){
        context.commit('initMountingMaterialModule', payload);
    },
    resetState(context : any)
    {
        context.commit('resetState');
    }
};

const mutations = {
    resetState(s: any) {
        Object.assign(s, getDefaultState());
        s.mountingMaterialListItems = [];
        s.mountingMaterialListItemsForSap = [];
    },
    updateStepCharacteristics(s: any, payload: any) {
        s.model.characteristics = payload.characteristics;
    },
    updateChildCharacteristics(s: any, payload: any) {
        s.model.childCharacteristics = payload.characteristics;
    },
    updateSingleCharacteristicsFilteredOrDefaults(s: any) {
        addSingleCharacteristicsFilteredOrDefaults(s);
    },
    updateMountingMaterialList(s: any, payload: any) {
        s.mountingMaterialListItems.push(payload);
    },
    updateMountingMaterialListForSap(s: any, payload: any) {
        s.mountingMaterialListItemsForSap.push(payload);
    },
    updateBlindstockForSap(s: any, payload: any) {
        for(let i = 0; i< payload.data.length; i++) {
            s.mountingMaterialListItemsForSap[payload.index].find((x: any) => x.code == payload.data[i].code).value = payload.data[i].value;
        }
    },
    updateCharacteristicDependencies(s: any, payload: any) {
        const characteristic = payload.characteristics[0];
        // console.log(characteristic.code);
        if (typeof characteristic !== 'undefined') {
            addOrReplaceCharacteristic(characteristic, s);

            // Dont need to add sigle characteristics. This step deiffers from other steps.
            // addSingleCharacteristicsFilteredOrDefaults(s);
        }
    },
    clearMountingMaterialList(s: any, payload : any) {
        let index = s.mountingMaterialListItems
            .map((x:any) => { return x.id; }).indexOf(payload.id);
        s.mountingMaterialListItems.splice(index, 1);

        const mountingMaterialColors = filterMountingMaterialColor();
        const selectMountingMaterialColor = mountingMaterialColors.find(x => x.name === payload.farbe.value.value);

        for(let i = 0 ; i< s.mountingMaterialListItemsForSap.length; i++) {
            if(payload.grosse.code === 'KTU_MM_ABDECKLEISTE') {
                let getValue = getValueOfArt('KTU_MM_ABDECKLEISTE_O_ART',payload.beschichtungsseite.value.value, s);
                if(s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === payload.anzahl.code).value === payload.anzahl.value.value &&
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === payload.breite.code).value === payload.breite.value.value &&
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === 'KTU_MM_ABDECKLEISTE_O').value === selectMountingMaterialColor?.value &&
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === 'KTU_MM_ABDECKLEISTE_O_SO').value === selectMountingMaterialColor?.original &&
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === 'KTU_MM_ABDECKLEISTE_O_ART').value === getValue &&
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === payload.grosse.code).value === payload.grosse.value.value &&
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === payload.laenge.code).value === payload.laenge.value.value &&
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === payload.hoehe.code).value === payload.hoehe.value.value
                ) {
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === payload.anzahl.code).value = '';
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === payload.breite.code).value = '';
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === 'KTU_MM_ABDECKLEISTE_O').value = '';
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === 'KTU_MM_ABDECKLEISTE_O_SO').value = '';
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === 'KTU_MM_ABDECKLEISTE_O_ART').value = '';
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === payload.grosse.code).value = '';
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === payload.laenge.code).value = '';
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === payload.hoehe.code).value ='';
                }
            }
            else if (payload.grosse.code === 'KTU_MM_WINKEL') {
                let getValue = getValueOfArt('KTU_MM_WINKEL_O_ART',payload.beschichtungsseite.value.value, s);
                if(s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === payload.anzahl.code).value === payload.anzahl.value.value &&
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === payload.breite.code).value === payload.breite.value.value &&
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === 'KTU_MM_WINKEL_O').value === selectMountingMaterialColor?.value &&
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === 'KTU_MM_WINKEL_O_SO').value === selectMountingMaterialColor?.original &&
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === 'KTU_MM_WINKEL_O_ART').value === getValue &&
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === payload.grosse.code).value === payload.grosse.value.value &&
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === payload.laenge.code).value === payload.laenge.value.value
                ) {
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === payload.anzahl.code).value = '';
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === payload.breite.code).value = '';
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === 'KTU_MM_WINKEL_O').value = '';
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === 'KTU_MM_WINKEL_O_SO').value = '';
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === 'KTU_MM_WINKEL_O_ART').value = '';
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === payload.grosse.code).value = '';
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === payload.laenge.code).value = '';
                }
            }

            else if (payload.grosse.code === 'KTU_MM_MDF') {
                if(s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === payload.anzahl.code).value === payload.anzahl.value.value &&
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === payload.breite.code).value === payload.breite.value.value &&
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === payload.grosse.code).value === payload.grosse.value.value &&
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === payload.laenge.code).value === payload.laenge.value.value &&
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === payload.hoehe.code).value === payload.hoehe.value.value
                ) {
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === payload.anzahl.code).value = '';
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === payload.breite.code).value ='';
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === payload.grosse.code).value ='';
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === payload.laenge.code).value ='';
                    s.mountingMaterialListItemsForSap[i].find((x:any) => x.code === payload.hoehe.code).value ='';
                }
            }

            let obj = [];
            for(let j = 0; j < s.mountingMaterialListItemsForSap[i].length; j++) {
                obj.push(s.mountingMaterialListItemsForSap[i][j].value);
            }
            let shouldRemoveObject = !obj.some((val) => val !== '');
            if(shouldRemoveObject) {
                s.mountingMaterialListItemsForSap.splice(i, 1);
            }
        }
    },
    initMountingMaterialModule(state : any, payload : any)
    {
        state.mountingMaterialListItems = payload.mountingMaterialListItems;
        state.mountingMaterialListItemsForSap = payload.mountingMaterialListItemsForSap;
        state.model.childCharacteristics = payload.model.childCharacteristics;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};

const getValueOfArt = (characteristic: string,data:any, s: any) => {
    let values = getCharacteristic(characteristic, s).values;
    for(let i = 0; i< values.length; i++) {
        let splitValue = values[i].value.split(' ');
        if(data === splitValue[1]) {
            return values[i].value;
        }
        else if(data === splitValue[0]) {
            return values[i].value;
        }
        else if(data === splitValue[0].replace("-", "")) {
            return values[i].value;
        }
    }
}

// Helper Methods
const addSingleCharacteristicsFilteredOrDefaults = (s: any) => {
    const frameCharacteristics = s.model.characteristics;
    frameCharacteristics.forEach((char: any) => {
        if (char.values.length === 1) {
            const selectedCharacteristic = MapCharacteristicAndValue(char, char.values[0]);
            const currentDoorConfiguration = store.getters['configuratorModule/getCurrentDoorConfiguration'];
            currentDoorConfiguration.Add(DoorConfiguration.Measure, selectedCharacteristic);
        } else {
            var geter = store.getters['configuratorModule/getRegisteredCharacteristicsValue'];
            const regChar = geter(char.code, DoorConfiguration.Measure);
            const exists = regChar.id === char.id;
            const registeredValue = char.values.filter((x: any) => x.id === regChar.value.id)[0];
            const incorrectValue = typeof registeredValue === 'undefined' ? true : false;
            if (exists === false || incorrectValue === true) {
                const valueItem = char.values[0];
                const selectedCharacteristic2 = MapCharacteristicAndValue(char, valueItem);
                const currentDoorConfiguration = store.getters['configuratorModule/getCurrentDoorConfiguration'];
                currentDoorConfiguration.Add(DoorConfiguration.Measure, selectedCharacteristic2);
            }
        }
    });
};

// used for managing dependencies
const addOrReplaceCharacteristic = (returnedCharacteristic: any, s: any) => {
    const characteristic = returnedCharacteristic;
    const modelCharacteristics = s.model.characteristics;

    let filteredCharacteristic: any;
    filteredCharacteristic = modelCharacteristics.filter((item: any) => item.code === characteristic.code);
    if (filteredCharacteristic.length !== 0) {
        if (filteredCharacteristic[0].id === characteristic.id) {
            const characteristicIndex: number = modelCharacteristics.indexOf(filteredCharacteristic[0]);
            modelCharacteristics.splice(characteristicIndex, 1, characteristic);
        }
    } else {
        modelCharacteristics.push(characteristic);
    }
};

const getCharacteristic = (code: string, s: any) => {
    const filteredCharacteristic = s.model.characteristics.filter((characteristic: any) => characteristic.code === code)[0];

    if (typeof filteredCharacteristic !== 'undefined') {
        return filteredCharacteristic;
    } else {
        return s.defaultCharacteristicObject;
    }
};

const getNrOfValues = (code: string, s: any) => {
    const filteredCharacteristic = s.model.characteristics.filter((characteristic: any) => characteristic.code === code)[0];
    if (typeof filteredCharacteristic !== 'undefined') {

        return filteredCharacteristic.values.length;
    } else {
        return 0;
    }
};

const checkValue = (characteristicCode: string, value: string, s: any) => {
    const definedValues = store.state.configuratorModule.doorConfiguration.Get(DoorConfiguration.Measure);
    const filteredCharacteristic: any = definedValues.filter((item: any) => item.code === characteristicCode && item.value.value === value)[0];

    if (filteredCharacteristic != null || typeof filteredCharacteristic !== 'undefined') {
        return true;
    }
    return false;
};

// used for checkboxes
const getAppropValue = (characteristicCode: string, context: any) => {
    const characteristic = getCharacteristic(characteristicCode, context.state);
    var geter = store.getters['configuratorModule/getRegisteredCharacteristicsValue'];
    const registeredCharacteristic = geter(characteristicCode, DoorConfiguration.Measure);
    let valueDefinition;

    if (characteristic.values.length > 1) {
        valueDefinition = characteristic.values.filter((x: any) => x.id !== registeredCharacteristic.value.id)[0];
    } else {
        valueDefinition = characteristic.values[0];
    }

    const selectedCharacteristic = MapCharacteristicAndValue(characteristic, valueDefinition);
    return selectedCharacteristic;
};